///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthProgressWindowService } from '../../../../project-windows/progress-window/progress-window.service';
import { BomConfigDTO } from '../../../../../generated/shared-types.model';

export class GtthGetProjectBomCommand extends GtthAbstractCommand {
    bomConfig: BomConfigDTO;

    getCommandName(): string {
        return 'GtthGetProjectBomCommand';
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (!activityDTO.successful) {
            if (activityDTO.error.message.startsWith(GtthProgressWindowService.BU_DEVICE_ORIENTATION_COLLISION_ERROR)) {
                this.historyService.reportsService.setTopologyValidityToCache(activityDTO.error.topologyValidity);
                // if Design Rings'
                setTimeout(() => {
                    this.historyService.router.navigate([{ outlets: { popup: `project-view/connected-sites` } }], { replaceUrl: true });
                }, 200);
            }
            if (activityDTO?.error?.message) {
                this.historyService.notificationService.showError(activityDTO.error.message);
            }
        }

        this.bomConfig = activityDTO.bomConfig;

        if (this.commandResolve) {
            this.commandResolve(activityDTO.successful);
        }
    }

    protected doCommand(): void {
        const getBomActivity = this.createActivityDTO(false);
        this.sendActivity(getBomActivity);
    }
}
